import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AgentesPage } from './pages/AgentesPage';
import { DuenosAgenciaPage } from './pages/DuenosAgenciaPage';
import { ComoFuncionaPage } from './pages/ComoFuncionaPage';
import { ResultadosPage } from './pages/ResultadosPage';
import { RecursosPage } from './pages/RecursosPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { DisclaimerPage } from './pages/DisclaimerPage';
import { ContactoPage } from './pages/ContactoPage';
import { AuditoriaPage } from './pages/AuditoriaPage';
import { AfiliadosPage } from './pages/AfiliadosPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-charcoal text-white flex flex-col" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-1" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/agentes" element={<AgentesPage data-id="element-9" />} data-id="element-8" />
            <Route path="/duenos-de-agencia" element={<DuenosAgenciaPage data-id="element-11" />} data-id="element-10" />
            <Route path="/como-funciona" element={<ComoFuncionaPage data-id="element-13" />} data-id="element-12" />
            <Route path="/resultados" element={<ResultadosPage data-id="element-15" />} data-id="element-14" />
            <Route path="/recursos" element={<RecursosPage data-id="element-17" />} data-id="element-16" />
            <Route path="/recursos/:slug" element={<BlogPostPage data-id="element-19" />} data-id="element-18" />
            <Route path="/auditoria" element={<AuditoriaPage data-id="element-21" />} data-id="element-20" />
            <Route path="/afiliados" element={<AfiliadosPage data-id="element-23" />} data-id="element-22" />
            <Route path="/contact-us" element={<ContactoPage data-id="element-25" />} data-id="element-24" />
            <Route path="/privacy" element={<PrivacyPage data-id="element-27" />} data-id="element-26" />
            <Route path="/terms" element={<TermsPage data-id="element-29" />} data-id="element-28" />
            <Route path="/disclaimer" element={<DisclaimerPage data-id="element-31" />} data-id="element-30" />
          </Routes>
        </main>
        <Footer data-id="element-32" />
      </div>
    </BrowserRouter>;
}